<template>
    <div class="img-swiper" @mouseover="onMouseover" @mouseout="onMouseout">
        <swiper :options="swiperOption" ref="imgSwiper">
            <swiper-slide 
                v-for="(item, index) in list"
                :key="index">
                <img class="slide-image" :src="item.url" @click="onSelectImg(item)">
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination" v-show="list.length !== 1"></div>
        </swiper>
    </div>
</template>

<style scoped>
.img-swiper >>> .slide-image {
    display: block;
    margin: auto;
    width: 100%;
    cursor: pointer;
}
.img-swiper >>> .swiper-pagination-bullet-active {
    background: #f4f2f2;
}
</style>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    props: {
        list: Array
    },
    data(){
        return {
            swiperOption: {
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            }
        }
    },
    components: {
        swiper,
        swiperSlide
    },
    created(){
        this.init()
    },
    beforeDestroy() {
        if(this.$refs['imgSwiper'].swiper){
            this.$refs['imgSwiper'].swiper.destroy(true, true)
        }
    },
    methods: {
        init(){
            if(this.list.length === 1){
                this.swiperOption.autoplay = false
                this.swiperOption.loop = false
            }
        },
        onMouseover(){
            this.$refs['imgSwiper'].swiper.autoplay.stop()
        },
        onMouseout(){
            this.$refs['imgSwiper'].swiper.autoplay.start()
        },
        onSelectImg(obj){
            this.$emit('select', obj)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/img-swiper.vue